export default class Loader {

  constructor(debug = false) {

    this.debug = debug;

    if (this.debug) console.log('Loader init');

    if (this.setVars()) {
      if (this.debug) console.log('Loader vars init done');
      this.setEvents();
      this.rescueMe();
    }
  }

  setVars()
  {
    this.RESCUE_ME_TIMEOUT = 5000;
    this.loaderEl = document.querySelector('.jsLoader');
    if (!this.loaderEl) return false;

    return true;
  }

  setEvents()
  {
    if (this.debug) console.log('Loader setting events');

    window.addEventListener('load', () => {
      if (this.debug) console.log('Loader page load event');
      this.loaderEl.classList.remove('active');
    });
  }

  rescueMe()
  {
    setTimeout(() => {
      if (this.debug) console.log('Loader rescueMe help', this.loaderEl);
      this.loaderEl.classList.remove('active');
    }, this.RESCUE_ME_TIMEOUT);
  }
}
